export default [
    {
		name: "Kampung Budiman",
		lat: 3.154464,
		lng: 101.4670012,
	},
    {
		name: "Kampung Baru Sg. Buloh",
		lat: 3.19323195,
		lng: 101.56616945,
	},
	{
		name: "Kampung Kubu Gajah",
		lat: 3.2010141,
		lng: 101.5151841,
	},
   
    {
		name: "Paya Jaras",
		lat: 3.201735,
		lng: 101.5473128,
	},
    {
		name: "Kampung Melayu Subang",
		lat: 3.160453,
		lng: 101.5326529,
	},
    {
		name: "Stesen Komuter Batu Tiga",
		lat: 3.0758449,
		lng: 101.5597796,
	},
    {
		name: "Kampung Bersatu Batu 13",
		lat: 3.019162,
		lng: 101.5997879,
	},
    {
		name: "Kampung Tengah",
		lat: 3.016435,
		lng: 101.5922452,
	},
    {
		name: "Kampung Kuala Sungai Baru",
		lat: 2.9918153,
		lng: 101.5802319,
	},
    {
		name: "Kampung Aman Bestari",
		lat: 3.00306,
		lng: 101.5930451,
	},
    {
		name: "IOI Business Centre",
		lat: 3.0423997,
		lng: 101.6193513,
	},
    {
		name: "Jalan Kuyuh Sri Kembangan",
		lat: 3.0289315,
		lng: 101.7048105,
	},
    {
		name: "Kompleks Pertanian Serdang",
		lat: 2.9960018,
		lng: 101.7008552,
	},
]